import styled, { css } from 'styled-components';
import {} from './index.js';
import { SEM_BORDER_RADIUS_UI_RADIUS_MAX } from '../../tokens/border-radius.generated.js';
import { SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_2400, SYS_SIZE_FIXED_600 } from '../../tokens/sizing.generated.js';
import { getTypographyStyles } from '../../utils/index.js';
import { SEM_TYPOGRAPHY_UI_SM_LABEL, SEM_TYPOGRAPHY_UI_MD_LABEL } from '../../tokens/typography.generated.js';
export const StyledAvatar = styled.button `
  padding: 0;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  border-radius: ${SEM_BORDER_RADIUS_UI_RADIUS_MAX};
  background-color: ${(props) => props.variant === 'logged-in'
    ? props.theme.sem.color.ui.surface.fill.default
    : 'transparent'};
  // TODO: token missing;
  transition-property: background-color, color;
  transition-duration: 250ms;
  transition-timing-function: ease;
  color: ${(props) => props.variant === 'logged-in'
    ? props.theme.sem.color.ui.foreground.text.secondary
    : props.theme.sem.color.ui.foreground.icons.default};

  ${(props) => {
    if (props.size === 'sm') {
        return css `
        height: ${SYS_SIZE_FIXED_600};
        width: ${SYS_SIZE_FIXED_600};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)}
      `;
    }
    if (props.size === 'md') {
        return css `
        height: ${SYS_SIZE_FIXED_1200};
        width: ${SYS_SIZE_FIXED_1200};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)}
      `;
    }
    return css `
      height: ${SYS_SIZE_FIXED_2400};
      width: ${SYS_SIZE_FIXED_2400};
      // TODO: label should be LG, but no token exists for this yet.
      font-family: AudiType, sans-serif;
      letter-spacing: 0px;
      font-weight: 400;
      font-size: 24px;
      line-height: 30px;
      font-stretch: 105%;
    `;
}}

  &:disabled {
    cursor: not-allowed;
  }

  ${(props) => props.variant === 'logged-in' &&
    css `
      &:hover:not(:disabled) {
        background-color: ${(props) => props.theme.sem.color.ui.surface.fill.hover};
      }

      &:active:not(:disabled) {
        background-color: ${(props) => props.theme.sem.color.ui.surface.fill.pressed};
      }

      &:disabled {
        background-color: ${(props) => props.theme.sem.color.ui.surface.fill.disabled};
      }
    `}

  ${(props) => props.variant === 'logged-out' &&
    css `
      &:hover:not(:disabled) {
        color: ${(props) => props.theme.sem.color.ui.foreground.icons.hover};
      }

      &:active:not(:disabled) {
        color: ${(props) => props.theme.sem.color.ui.foreground.icons.pressed};
      }

      &:disabled {
        color: ${(props) => props.theme.sem.color.ui.foreground.icons.disabled};
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map